export enum ConfirmationModalType {
    frustate = 'frustate',
    message = 'message',
    button = 'button',
}
